import type { IconButtonProps } from '@mui/material';
import { VyIcon } from '@weft/icons';
import { HomePageSidebarButtonWrapper } from './HomePageSidebarButtonWrapper';

type HomePageSidebarIntegrationsButtonProps = {
  isSelected?: boolean;
} & IconButtonProps;

export const HomePageSidebarIntegrationsButton: React.FC<HomePageSidebarIntegrationsButtonProps> = ({ isSelected, ...buttonProps }) => {
  return (
    <HomePageSidebarButtonWrapper
      isSelected={isSelected}
      {...buttonProps}
    >
      <VyIcon
        color='#323232'
        icon="PuzzlePlugInAdd"
      />
    </HomePageSidebarButtonWrapper>
  );
};